import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { useFormStore } from "../hooks/use-form-store.js";
import { FormProvider } from "./form-provider.js";
export function ShapeForm({ store, widgets, runtimeContext, onSubmit, children, className, id }) {
    const submit = useStore(store, (s) => s.submit);
    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        await submit();
        const state = store.getState();
        if (state.isValid && onSubmit)
            await onSubmit(state.values);
    }, [store, submit, onSubmit]);
    return (_jsx(FormProvider, { store: store, widgets: widgets, runtimeContext: runtimeContext, children: _jsx("form", { onSubmit: handleSubmit, className: className, id: id, children: children }) }));
}
/**
 * Displays form validation status and error count.
 * Useful for debugging or showing users the form state.
 */
export function FormStatus({ showErrors = true, showState = false, className }) {
    const store = useFormStore();
    const { isValid, isValidating, errorCount, isDirty, touchedCount } = useStore(store, useShallow((s) => ({
        isValid: s.isValid,
        isValidating: s.isValidating,
        errorCount: Object.keys(s.errors).length,
        isDirty: s.isDirty,
        touchedCount: s.touched.size
    })));
    if (isValid && !showState)
        return null;
    return (_jsxs("div", { className: `text-sm ${className ?? ''}`, children: [isValidating && _jsx("span", { className: "text-info", children: "Validating..." }), showErrors && !isValid && errorCount > 0 && (_jsxs("span", { className: "text-error", children: [errorCount, " ", errorCount === 1 ? 'error' : 'errors'] })), showState && (_jsxs("span", { className: "text-base-content/70 ml-2", children: [isDirty ? 'Modified' : 'Unchanged', " \u00B7 ", touchedCount, " fields touched"] }))] }));
}
export function SubmitButton({ children = 'Submit', className, disableWhenInvalid = true, showLoading = true }) {
    const store = useFormStore();
    const { isSubmitting, isValid } = useStore(store, useShallow((s) => ({
        isSubmitting: s.isSubmitting,
        isValid: s.isValid
    })));
    const disabled = isSubmitting || (disableWhenInvalid && !isValid);
    return (_jsx("button", { type: "submit", className: `btn btn-primary ${className ?? ''}`, disabled: disabled, children: showLoading && isSubmitting ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "loading loading-spinner loading-sm" }), "Submitting..."] })) : (children) }));
}
